/* Flower Delivery Dubai — animated placeholder + predictive search */
(function(){
  var PH=["Search for roses","Search for red roses","Search for birthday flowers","Search for anniversary flowers","Search for lilies","Search for tulips","Search for sunflowers","Search for hydrangeas"];
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function debounce(fn,ms){var t;return function(){var a=arguments,c=this;clearTimeout(t);t=setTimeout(function(){fn.apply(c,a);},ms);};}
  function typewriter(inputs){
    var i=0,j=0,del=false;
    function tick(){
      var full=PH[i],txt=full.substring(0,j);
      inputs.forEach(function(el){ if(!el.value){ el.setAttribute('placeholder',txt); } });
      if(!del){ if(j<full.length){ j++; setTimeout(tick,70);} else { del=true; setTimeout(tick,1500);} }
      else { if(j>0){ j--; setTimeout(tick,35);} else { del=false; i=(i+1)%PH.length; setTimeout(tick,250);} }
    }
    tick();
  }
  function setup(form){
    var input=form.querySelector('input[type="search"]');
    if(!input) return;
    var box=document.createElement('div');
    box.className='fdd-suggest'; box.style.display='none';
    form.appendChild(box);
    var run=debounce(function(){
      var q=input.value.trim();
      if(q.length<2){ box.style.display='none'; box.innerHTML=''; return; }
      fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function(r){return r.json();})
      .then(function(d){
        var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
        if(!items.length){ box.innerHTML='<div class="fdd-suggest__empty">No matches for &ldquo;'+esc(q)+'&rdquo;</div>'; box.style.display='block'; return; }
        var html=items.map(function(p){
          var img=p.image?'<img src="'+p.image+'" alt="" loading="lazy">':'<span class="fdd-suggest__noimg"></span>';
          return '<a class="fdd-suggest__item" href="'+p.url+'">'+img+'<span class="fdd-suggest__t">'+esc(p.title)+'</span></a>';
        }).join('');
        html+='<a class="fdd-suggest__all" href="/search?q='+encodeURIComponent(q)+'&type=product">See all results for &ldquo;'+esc(q)+'&rdquo;</a>';
        box.innerHTML=html; box.style.display='block';
      }).catch(function(){ box.style.display='none'; });
    },220);
    input.addEventListener('input',run);
    input.addEventListener('focus',function(){ if(box.innerHTML) box.style.display='block'; });
    document.addEventListener('click',function(e){ if(!form.contains(e.target)) box.style.display='none'; });
  }
  function init(){
    var forms=document.querySelectorAll('.fdd-search-form, .fdd-msearch');
    if(!forms.length) return;
    var inputs=[];
    forms.forEach(function(f){ setup(f); var i=f.querySelector('input[type="search"]'); if(i) inputs.push(i); });
    if(inputs.length) typewriter(inputs);
  }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
